import React, {forwardRef, memo, useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {batchActions} from 'redux-batched-actions';

import getPath from '@neonaut/lib-js/es/object/getPath';

import usePrevious from '@mapsight/ui/src/js/hooks/usePrevious';
import modClasses from '@mapsight/ui/src/js/helpers/mod-classes';
import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_DESKTOP, VIEW_FULLSCREEN} from '@mapsight/ui/src/js/config/constants/app';

import {useNavPos} from '../../../hooks';

import {setLanguageOpen, setNavigationOpen} from '../../store/actions';
import {featureSelectionSelector, navOpenSelector} from '../../store/selectors';


export default memo(forwardRef(
	function MenuButton({tabIndex}, ref) {
		const navPos = useNavPos();
		const dispatch = useDispatch();
		const openByButton = useSelector(navOpenSelector);
		const view = useSelector(viewSelector);
		const openByView = view === VIEW_DESKTOP || view === VIEW_FULLSCREEN;
		const open = openByButton || openByView;

		// close menu on (map)-selection. Nachteil dieser Lösung ist, dass beim Reselect das Menü offen bleibt.
		const featureSelections = useSelector(featureSelectionSelector);
		const oldFeatureSelections = usePrevious(featureSelections);
		useEffect(function () {
				if (openByButton && featureSelections !== oldFeatureSelections && getPath(featureSelections, ['features', 'length'])) {
					dispatch(batchActions([
						setLanguageOpen(false),
						setNavigationOpen(false)
					]));
				}
			},
			[openByButton, featureSelections, oldFeatureSelections, dispatch]
		);

		const toggleOpen = useCallback(
			function toggleOpen() {
				dispatch(batchActions([
					setLanguageOpen(false),
					setNavigationOpen(!openByButton)
				]));
			},
			[openByButton, dispatch],
		);

		if(openByView) {
			return null;
		}

		const menuTitle = navPos.app?.lang === 'en' ? 'Main Menu' : 'Hauptmenü';
		// const menuText = navPos.app?.lang === 'en' ? 'Menu' : 'Menü';
		return (
			<button
				onClick={toggleOpen}
				className="stade-menu-button"
				title={menuTitle}
				aria-label={menuTitle}
				aria-controls="stade-menu-nav"
				aria-expanded={open}
				ref={ref}
				tabIndex={tabIndex}
			>
				<div className="stade-menu-button__img-wrapper">
					<div
						className={modClasses('stade-menu-button__img', {
							menu: true,
							visible: !open,
						})}
					/>
					<div
						className={modClasses('stade-menu-button__img', {
							'menu-close': true,
							visible: open,
						})}
					/>
				</div>
			</button>
		);
	}
));
